import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/wanghong-fanche', label: '网红翻车' },
    { to: '/category/heila-baoliao', label: '黑料爆料' },
    { to: '/category/jieri-dagua', label: '今日大瓜' },
    { to: '/category/yule-bagua', label: '娱乐八卦' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'fixed top-0 bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'absolute top-0 bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className={`ri-fire-line text-2xl ${isScrolled ? 'text-primary-500' : 'text-white'}`}></i>
          </div>
          <span className={`font-heading font-bold text-xl ${isScrolled ? 'text-foreground-900' : 'text-white'}`}>
            吃瓜官网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.to
                  ? isScrolled
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : isScrolled
                    ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <button className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200 bg-white/10 hover:bg-white/20 text-white">
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer"
        >
          <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${isScrolled ? 'text-foreground-900' : 'text-white'}`}></i>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}